import React, { useEffect, useMemo, useState } from 'react';
import {
  Box,
  Typography,
  Card,
  CardContent,
  Grid,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  Checkbox,
  FormControlLabel,
  Autocomplete,
} from '@mui/material';
import { AssignmentTurnedIn as AssignmentTurnedInIcon, Save as SaveIcon } from '@mui/icons-material';
import { useHistory, useLocation } from 'react-router-dom';

const AssignTechnician = () => {
  const history = useHistory();
  const location = useLocation();
  const [header, setHeader] = useState({
    requestId: '',
    project: '',
    date: '',
    shift: 'General',
    customerName: '',
    customerPhone: '',
    siteAddress: '',
    customerId: '',
    serviceType: '',
    status: 'Pending',
    timeSlot: '',
  });

  const openRequests = useMemo(() => ([
    { id: 'SR-1001', project: 'Rooftop A1', customerName: 'Priya', customerId: 'C-001', customerPhone: '+91 90000 00011', siteAddress: '12 Green Park, Phase II, Pune, MH 411001', serviceType: 'Installation' },
    { id: 'SR-1002', project: 'Ground C2', customerName: 'Rahul', customerId: 'C-002', customerPhone: '+91 90000 00022', siteAddress: '22 Solar Street, Indore, MP 452001', serviceType: 'Repair' },
  ]), []);

  const technicians = useMemo(() => ([
    { id: 'T-001', name: 'Amit Kumar', phone: '+91 90000 00001', skills: ['Electrical', 'EV Charger'] },
    { id: 'T-002', name: 'Riya Sharma', phone: '+91 90000 00002', skills: ['Solar', 'Wiring'] },
    { id: 'T-003', name: 'Vikram Singh', phone: '+91 90000 00003', skills: ['Supervisor', 'Safety'] },
    { id: 'T-004', name: 'Rahul Verma', phone: '+91 90000 00004', skills: ['Battery', 'Maintenance'] },
  ]), []);

  const [selectedTechs, setSelectedTechs] = useState([]);
  const [selectedTech, setSelectedTech] = useState(null);
  const [notes, setNotes] = useState('');
  const [safetyBriefing, setSafetyBriefing] = useState(true);

  const handleSubmit = () => {
    if (!header.requestId || !header.date) {
      alert('Select Service Request and Date');
      return;
    }
    if (!header.customerName || !header.siteAddress) {
      alert('Customer Name and Site Address are required');
      return;
    }
    if (!selectedTech) {
      alert('Select a technician');
      return;
    }
    const payload = { ...header, technician: { id: selectedTech.id, name: selectedTech.name, phone: selectedTech.phone }, notes, safetyBriefing };
    console.log('Assign Technician payload:', payload);
    alert('Technicians assigned (demo)');
  };

  const fillTemplate = () => {
    setSelectedTechs([technicians[0], technicians[1], technicians[2]].filter(Boolean));
  };

  const handleCancel = () => {
    history.push('/app/green-energy/service/request-list');
  };

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const sr = params.get('sr');
    if (sr) {
      const found = openRequests.find(x => x.id === sr);
      setHeader(prev => ({ ...prev, requestId: sr, project: found ? found.project : prev.project }));
    }
  }, [location.search, openRequests]);

  return (
    <Box sx={{ p: 3, backgroundColor: '#f5f5f5', minHeight: '100vh' }}>
      <Box sx={{ mb: 3 }}>
        <Box display="flex" justifyContent="space-between" alignItems="center" flexWrap="wrap" gap={2}>
          <Box>
            <Typography variant="h4" sx={{ fontWeight: 700, color: '#000', mb: 0.5 }}>
              Assign Technician
            </Typography>
            <Typography variant="body2" color="text.secondary">Assign technicians to open service requests</Typography>
          </Box>
          {/* <Button variant="outlined" startIcon={<AssignmentTurnedInIcon />} onClick={fillTemplate}>Templates</Button> */}
        </Box>
      </Box>

      {/* Assignment Form */}
      <Card sx={{ mb: 2 }}>
        <CardContent>
          <Grid container spacing={2}>
            <Grid item xs={12} md={4}>
              <FormControl fullWidth size="small">
                <InputLabel>Service Request</InputLabel>
                <Select value={header.requestId} label="Service Request" onChange={(e) => {
                  const val = e.target.value;
                  const found = openRequests.find(x => x.id === val);
                  setHeader(prev => ({
                    ...prev,
                    requestId: val,
                    project: found?.project || '',
                    customerName: found?.customerName || '',
                    customerId: found?.customerId || '',
                    customerPhone: found?.customerPhone || '',
                    siteAddress: found?.siteAddress || '',
                    serviceType: found?.serviceType || '',
                  }));
                }}>
                  <MenuItem value="">Select</MenuItem>
                  {openRequests.map(r => <MenuItem key={r.id} value={r.id}>{r.id} • {r.project}</MenuItem>)}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={4}>
              <TextField fullWidth size="small" label="Project" value={header.project} onChange={(e) => setHeader(prev => ({ ...prev, project: e.target.value }))} />
            </Grid>
            <Grid item xs={12} md={4}>
              <TextField fullWidth size="small" label="Customer Name" value={header.customerName} onChange={(e) => setHeader(prev => ({ ...prev, customerName: e.target.value }))} />
            </Grid>
            <Grid item xs={12} md={4}>
              <TextField fullWidth size="small" label="Customer ID" value={header.customerId} onChange={(e) => setHeader(prev => ({ ...prev, customerId: e.target.value }))} />
            </Grid>
            <Grid item xs={12} md={4}>
              <TextField fullWidth size="small" label="Customer Phone" value={header.customerPhone} onChange={(e) => setHeader(prev => ({ ...prev, customerPhone: e.target.value }))} />
            </Grid>
            <Grid item xs={12} md={4}>
              <TextField fullWidth size="small" label="Service ID (SR #)" value={header.requestId} InputProps={{ readOnly: true }} />
            </Grid>
            <Grid item xs={12} md={4}>
              <TextField fullWidth size="small" label="Service Type" value={header.serviceType} onChange={(e) => setHeader(prev => ({ ...prev, serviceType: e.target.value }))} />
            </Grid>
            <Grid item xs={12} md={2}>
              <TextField fullWidth size="small" type="date" label="Date" InputLabelProps={{ shrink: true }} value={header.date} onChange={(e) => setHeader(prev => ({ ...prev, date: e.target.value }))} />
            </Grid>
            <Grid item xs={12} md={2}>
              <FormControl fullWidth size="small">
                <InputLabel>Shift</InputLabel>
                <Select value={header.shift} label="Shift" onChange={(e) => setHeader(prev => ({ ...prev, shift: e.target.value }))}>
                  <MenuItem value="General">General</MenuItem>
                  <MenuItem value="Morning">Morning</MenuItem>
                  <MenuItem value="Evening">Evening</MenuItem>
                  <MenuItem value="Night">Night</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={2}>
              <FormControl fullWidth size="small">
                <InputLabel>Time Slot</InputLabel>
                <Select value={header.timeSlot} label="Time Slot" onChange={(e) => setHeader(prev => ({ ...prev, timeSlot: e.target.value }))}>
                  <MenuItem value="">Select</MenuItem>
                  <MenuItem value="10:00-12:00">10 AM – 12 PM</MenuItem>
                  <MenuItem value="12:00-14:00">12 PM – 2 PM</MenuItem>
                  <MenuItem value="14:00-16:00">2 PM – 4 PM</MenuItem>
                  <MenuItem value="16:00-18:00">4 PM – 6 PM</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <TextField fullWidth size="small" multiline rows={2} label="Site Address" value={header.siteAddress} onChange={(e) => setHeader(prev => ({ ...prev, siteAddress: e.target.value }))} />
            </Grid>
            <Grid item xs={12} md={4}>
              <Autocomplete
                size="small"
                options={technicians}
                getOptionLabel={(o) => o ? `${o.name} • ${o.phone}` : ''}
                value={selectedTech}
                onChange={(_, value) => setSelectedTech(value || null)}
                renderInput={(params) => <TextField {...params} label="Technician Name" placeholder="Select technician" />}
                filterOptions={(opts, state) => {
                  const v = (state.inputValue || '').toLowerCase();
                  return opts.filter(t => `${t.name} ${t.phone}`.toLowerCase().includes(v));
                }}
                clearOnEscape
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <TextField fullWidth size="small" label="Technician ID" value={selectedTech ? selectedTech.id : ''} InputProps={{ readOnly: true }} />
            </Grid>
            <Grid item xs={12} md={4}>
              <TextField fullWidth size="small" label="Technician Contact" value={selectedTech ? selectedTech.phone : ''} InputProps={{ readOnly: true }} />
            </Grid>
            <Grid item xs={12} md={4}>
              <FormControl fullWidth size="small">
                <InputLabel>Status</InputLabel>
                <Select value={header.status} label="Status" onChange={(e) => setHeader(prev => ({ ...prev, status: e.target.value }))}>
                  <MenuItem value="Pending">Pending</MenuItem>
                  <MenuItem value="Assigned">Assigned</MenuItem>
                  <MenuItem value="In Progress">In Progress</MenuItem>
                  <MenuItem value="Completed">Completed</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={8}>
              <FormControlLabel control={<Checkbox checked={safetyBriefing} onChange={(e) => setSafetyBriefing(e.target.checked)} color="primary" />} label="Include Safety Briefing" />
            </Grid>
            <Grid item xs={12}>
              <TextField fullWidth size="small" multiline rows={3} label="Notes / Special Instructions" value={notes} onChange={(e) => setNotes(e.target.value)} />
            </Grid>
          </Grid>
        </CardContent>
      </Card>

      {/* Actions */}
      <Card>
        <CardContent>
          <Box display="flex" gap={1} justifyContent="flex-end">
            <Button variant="outlined" onClick={handleCancel}>Cancel</Button>
            <Button variant="contained" startIcon={<SaveIcon />} onClick={handleSubmit} sx={{ backgroundColor: '#536DFE', '&:hover': { backgroundColor: '#3F51B5' } }}>Assign</Button>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
};

export default AssignTechnician;



